import { render } from "./ReceivingAccount.vue?vue&type=template&id=25ec9070&scoped=true"
import script from "./ReceivingAccount.vue?vue&type=script&lang=js"
export * from "./ReceivingAccount.vue?vue&type=script&lang=js"

import "./ReceivingAccount.vue?vue&type=style&index=0&id=25ec9070&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ec9070"]])

export default __exports__